var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabletDebug"},[_c('div',{staticClass:"debugPos"},[_vm._v("\n        scale: "+_vm._s(_vm.scale)+",\n        offset: "+_vm._s(_vm._f("round")(_vm.offset.x))+" "+_vm._s(_vm._f("round")(_vm.offset.y))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }